import { useEffect, useRef, useState } from 'react';

export function usePriceHighlight(current: number, isBuy: boolean) {
    const [isActive, setIsActive] = useState(false);
    const prevRef = useRef<number>(current);

    useEffect(() => {
        if (!isActive) {
            return;
        }
        const id = setTimeout(() => setIsActive(false), 500);
        return () => clearTimeout(id);
    }, [current, isActive]);

    useEffect(() => {
        const isEqual = isBuy
            ? current > prevRef.current
            : current < prevRef.current;
        if (isEqual) {
            setIsActive(true);
        }

        prevRef.current = current;
    }, [current, isBuy]);

    return isActive;
}
